// extracted by mini-css-extract-plugin
export default {"container":"ColorScheme_container__FFqLw","selected":"ColorScheme_selected__kMNFr","color":"ColorScheme_color__z8qJa"};